<template>
  <div class="d-flex justify-content-center align-items-center min-vh-100">
    <div class="text-center">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <h3>Completing authentication...</h3>
      <p class="text-muted">Please wait while we complete your login.</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import ApiClient from '@/ApiClient';

onMounted(async () => {
  try {
    const url = new URL(window.location.href);
    const params = {};

    url.searchParams.forEach((value, key) => {
      params[key] = value;
    });

    const code = url.searchParams.get('code');
    const state = url.searchParams.get('state');

    const response = await ApiClient.postADPSSOFinish({
      code: code,
      state: state,
      redirect_uri: `${window.location.origin}/adp-login-callback`,
    });

    if (response?.success) {
      window.location.href = '/dashboard';
    } else {
      console.error('Failed to complete ADP SSO flow:', response);
    }
  } catch (error) {
    console.error('Failed to complete ADP SSO flow:', error);
  }
});
</script>
